module.exports = __webpack_public_path__ + "TheStarfishface.webp?f6def239027035c0ddd68585c2d14ef8";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/TheStarfishface.webp
// module id = 165
// module chunks = 0